(function () {
  'use strict';

  function initGrid(grid) {
    var rowHeight = parseInt(getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10) || 8;
    var rowGap = parseInt(getComputedStyle(grid).getPropertyValue('gap'), 10) || 16;

    function applySpan(item, height) {
      if (!height) return;
      var span = Math.ceil((height + rowGap) / (rowHeight + rowGap));
      item.style.gridRowEnd = 'span ' + span;
    }

    // The image itself is stretched to `height: 100%` by CSS (for
    // object-fit: cover), so its own rendered box height is circular —
    // it just reflects whatever height the item already has. Derive the
    // real height instead from the image's natural aspect ratio applied
    // to the item's current (column-driven) width.
    function sizeImageItem(img) {
      var item = img.closest('[data-masonry-item]');
      if (!item || !img.naturalWidth || !img.naturalHeight) return;
      var width = item.getBoundingClientRect().width;
      applySpan(item, width * (img.naturalHeight / img.naturalWidth));
    }

    function sizePlaceholderItem(item) {
      var placeholder = item.querySelector('.lookbook-masonry__placeholder');
      if (!placeholder) return;
      applySpan(item, placeholder.getBoundingClientRect().height);
    }

    function sizeAll() {
      grid.querySelectorAll('[data-masonry-item]').forEach(function (item) {
        var img = item.querySelector('img');
        if (img) {
          sizeImageItem(img);
        } else {
          sizePlaceholderItem(item);
        }
      });
    }

    // Size once each image has actually loaded, so we're measuring its
    // real natural dimensions rather than a not-yet-available 0x0 image.
    grid.querySelectorAll('img').forEach(function (img) {
      if (img.complete) {
        sizeImageItem(img);
      } else {
        img.addEventListener('load', function () {
          sizeImageItem(img);
        });
      }
    });

    // Items without an image (editor placeholder state) size immediately.
    grid.querySelectorAll('[data-masonry-item]:not(:has(img))').forEach(sizePlaceholderItem);

    // Re-measure on resize (column width changes affect wrapped image height).
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sizeAll, 100);
    });

    return sizeAll;
  }

  function boot() {
    document.querySelectorAll('[data-masonry-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run when blocks are added/reordered/removed in the theme editor.
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
    document.addEventListener('shopify:block:deselect', boot);
  }
})();
